import React from 'react';
import WidgetHireMe from '../WidgetHireMe';
import WidgetRecentPosts from '../WidgetRecentPosts';
import WidgetSocial from '../WidgetSocial';

import './site-footer.css';

const SiteFooter = () => (
  <footer id="site-footer" className="site-footer">
    <section className="site-footer--widgets">
      <div className="site-footer--widgets-wrap">
        <WidgetHireMe />
        <WidgetRecentPosts />
      </div>
    </section>
    <div className="site-footer--wrap">
      <WidgetSocial />
      <div className="site-footer--copyright">Copyright ©&nbsp;2018, Jody Boucher</div>
    </div>
  </footer>
);

export default SiteFooter;



// WEBPACK FOOTER //
// ./src/components/SiteFooter/index.js